import React from "react";
import { observer } from "mobx-react-lite";

import { dateToMonth, declOfNum } from "../../lib/utils";
import searchStore from "../../store/searchStore";
import CloseIcon from "../ui/CloseIcon";

function BookingFormHeader({ title, datein, dateout, onClose }) {
  return (
    <div className="bookingForm__header mob_hide">
      <div className="bookingFormHeader__title">
        <h3>{title}</h3>
      </div>
      <div>
        <div className="bookingFormHeader__params">
          <span className="bookingForm__dates">
            {dateToMonth(datein)} – {dateToMonth(dateout)}
          </span>{" "}
          <span className="bookingForm__guests">
            {declOfNum(
              searchStore.guestsCount +
                (searchStore.guestsChildren?.length || 0),
              ["гость", "гостя", "гостей"],
            )}
          </span>
          <span className="curp mob_hide" onClick={onClose}>
            <CloseIcon w={16} h={16} />
          </span>
        </div>
      </div>
    </div>
  );
}

export default observer(BookingFormHeader);
